import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Error, Label } from "../..";
import { postAxios, putAxios } from "../../../Services/commonService";
import {
  API_CREATE_PERMISSION,
  API_UPDATE_PERMISSION_DATA,
} from "../../../../utils/api/ApiConstant";
import { PermissionSchema } from "../../../Schema/Configuration/PermissionSchema";

const PermissionModal = ({ handleModalHide, rowData, fetchData }) => {
  console.log("rowData", rowData);
  const isEdit = rowData && Object.keys(rowData).length > 0;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: rowData?.name ?? "",
      key: rowData?.key ?? "",
    },
    resolver: yupResolver(PermissionSchema),
  });

  const handleFormSubmit = async (payload) => {
    let res;
    if (isEdit) {
      const updatePayload = {
        name: payload?.name,
        key: payload?.key,
        isActive: rowData?.isActive,
        rowVersion: rowData?.rowVersion,
      };
      res = await putAxios(
        `${API_UPDATE_PERMISSION_DATA}/${rowData?.id}`,
        updatePayload,
      );
    } else {
      res = await postAxios(API_CREATE_PERMISSION, payload);
    }
    if (res) {
      fetchData();
      handleModalHide();
    }
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <div className="row m-0 p-0">
        <div className="col-lg-6 col-12 mb-2">
          <Label htmlFor="name" className="form-label" isRequired={true}>
            Name
          </Label>
          <input
            className="form-control"
            type="text"
            id="name"
            placeholder="enter name"
            {...register("name")}
          />
          {errors.name && <Error>{errors.name.message}</Error>}
        </div>
        <div className="col-md-6 m-0 p-1">
          <Label htmlFor="key" className="form-label" isRequired={true}>
            Key
          </Label>
          <input
            className="form-control"
            type="text"
            id="key"
            placeholder="enter key"
            {...register("key")}
          />
          {errors.key && <Error>{errors.key.message}</Error>}
        </div>
      </div>
      <Button type="submit" className="btn btn_main">
        {isEdit ? "Update" : "Create"}
      </Button>
      <Button type="button" className="btn btn_main" onClick={handleModalHide}>
        Close
      </Button>
    </form>
  );
};

export default PermissionModal;
